import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveVideoSuccess,
  saveVideoFailure,
  updateVideoSuccess,
  updateVideoFailure,
  deleteVideoSuccess,
  deleteVideoFailure,
  readVideoSuccess,
  readVideoFailure,
} from "./videoResourcesActions";

import {
  saveVideo,
  updateVideo,
  deleteVideo,
  readVideos,
} from "./videoResourcesAPI";

// ✅ Save Video
function* saveVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveVideoSuccess(res.data));
      toast.success(res.message || "Video saved successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else {
      throw new Error(res?.error || "Save failed");
    }
  } catch (error) {
    yield put(saveVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Update Video
function* updateVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateVideoSuccess(res.data));
      toast.success(res.message || "Video updated successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else {
      throw new Error(res?.error || "Update failed");
    }
  } catch (error) {
    yield put(updateVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Delete Video
function* deleteVideoSaga(action) {
  try {
    const { _id } = action.payload;
    const res = yield call(deleteVideo, { _id });

    if (res?.type === 1) {
      yield put(deleteVideoSuccess({ _id }));
      toast.success(res.message || "Video deleted successfully!");
      if (action.callback) action.callback({ type: 1, _id });
    } else {
      throw new Error(res?.error || "Delete failed");
    }
  } catch (error) {
    yield put(deleteVideoFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Read Videos
function* readVideosSaga(action) {
  try {
    const res = yield call(readVideos, action.payload);

    if (res?.type === 1) {
      yield put(readVideoSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else {
      throw new Error(res?.error || "Read failed");
    }
  } catch (error) {
    yield put(readVideoFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// ✅ Watcher
export default function* videoResourcesWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_VIDEO_REQUEST, saveVideoSaga);
  yield takeLatest(actionTypes.UPDATE_VIDEO_REQUEST, updateVideoSaga);
  yield takeLatest(actionTypes.DELETE_VIDEO_REQUEST, deleteVideoSaga);
  yield takeLatest(actionTypes.READ_VIDEO_REQUEST, readVideosSaga);
}
